'use client'

/**
 * Installeert de in-app history-index (zie `lib/history-index.ts`) waar de
 * `BackButton` op leunt. Eén keer in de root-layout van elke app mounten; rendert
 * niets.
 *
 * Volgorde ten opzichte van Next: dit effect draait vóór dat van de AppRouter
 * (kind-effecten eerst), dus Next wikkelt zijn eigen `pushState`/`replaceState`-
 * patch om de onze heen en elke Next-navigatie passeert onze wrapper.
 */

import { useEffect } from 'react'
import { installHistoryIndex } from '../lib/history-index'

export function HistoryIndexTracker() {
  useEffect(() => installHistoryIndex(window.history), [])
  return null
}
